import { useState } from 'react';

export const useConfirmation = () => {
  const [confirmationState, setConfirmationState] = useState({
    isOpen: false,
    title: '',
    message: '',
    onConfirm: null,
    confirmText: 'Confirm',
    cancelText: 'Cancel',
    type: 'warning',
    icon: null,
    isLoading: false
  });

  const showConfirmation = ({
    title,
    message,
    onConfirm,
    confirmText = 'Confirm',
    cancelText = 'Cancel',
    type = 'warning',
    icon = null
  }) => {
    return new Promise((resolve) => {
      setConfirmationState({
        isOpen: true,
        title,
        message,
        onConfirm: async () => {
          setConfirmationState(prev => ({ ...prev, isLoading: true }));
          try {
            if (onConfirm) {
              await onConfirm();
            }
            resolve(true);
          } catch (error) {
            console.error('Confirmation action failed:', error);
            resolve(false);
          } finally {
            closeConfirmation();
          }
        },
        confirmText,
        cancelText,
        type,
        icon,
        isLoading: false
      });
    });
  };

  const closeConfirmation = () => {
    setConfirmationState(prev => ({
      ...prev,
      isOpen: false,
      isLoading: false
    }));
  };

  return {
    confirmationState,
    showConfirmation,
    closeConfirmation
  };
};